import { generateTranslationByVenueType, translate } from '../../../../utils';
import { HeadCell } from '../../../../ui-kit/Table/types';
import { VenueType } from '../../../../generated/graphql';
import { Row } from './types';

export const getHeadCells = (venueType: VenueType): Array<HeadCell<Row>> => [
    { id: 'name', align: 'left', label: translate('Category Name') },
    { id: 'quantity', align: 'right', label: translate('Quantity') },
    {
        id: 'foodCost',
        align: 'right',
        label: generateTranslationByVenueType(
            {
                translations: {
                    Ecommerce: translate('COGS'),
                    Restaurant: translate('Food cost'),
                },
                venueType,
            },
        ),
    },
    { id: 'primeCost', align: 'right', label: translate('Prime cost') },
    { id: 'netMargin', align: 'right', label: translate('Markup') },
    { id: 'netRevenue', align: 'right', label: translate('Net Revenue') },
    { id: 'grossRevenue', align: 'right', label: translate('Gross Revenue') },
];